export function stringFormatDate (date, ignoreMidnight) {
  if (date === '' || date == null) return ''
  const dt = new Date(date)
  const time = dt.toLocaleTimeString()
  const dateStr = dt.toDateString()
  let temp = time.split(':')
  temp.splice(2, 1)
  let timeStr = temp.join(':')
  if (ignoreMidnight && time === '12:00:00 AM') return dateStr.substr(0, 3) + ',' + dateStr.substr(3, 7) + ',' + dateStr.substr(10)
  return dateStr.substr(0, 3) + ',' + dateStr.substr(3, 7) + ',' + dateStr.substr(10) + ' at ' + timeStr + time.substr(-3)
}

/**
 * This function determines the amount of time that has passed between the two given dates and returns a string with the difference. The precision determines how precise the
 * difference is, with each one including itself and all lower values (but not milliseconds).
 * @param {Date} first
 * @param {Date} second
 * @param {String} precision Defines what precision this should be (seconds, minutes, hours, days, months, years); with years, can be used to calculate age from birth date.
 */
export function dateDiff (first, second, precision) {
  let diff = Math.abs(first.getTime() - second.getTime()) / 1000
  let sec = Math.floor(diff % 60)
  diff /= 60
  let min = Math.floor(diff % 60)
  diff /= 60
  let hour = Math.floor(diff % 24)
  diff /= 24
  let day = Math.floor(diff % 30)
  diff /= 30
  let month = Math.floor(diff % 12)
  let year = Math.floor(diff / 12)
  // let year = Math.abs(first.getFullYear() - second.getFullYear())
  // let month = Math.abs(first.getMonth() - second.getMonth())
  // let day = Math.abs(first.getDate() - second.getDate())
  // let hour = Math.abs(first.getHours() - second.getHours())
  // let min = Math.abs(first.getMinutes() - second.getMinutes())
  // let sec = Math.abs(first.getSeconds() - second.getSeconds())

  let parts = []
  if (precision === 'years' || precision === 'year' || year > 0) {
    parts.push(year + ' year' + (year === 1 ? '' : 's'))
    if (precision === 'years' || precision === 'year') return parts.join(', ')
  }
  if (precision === 'months' || precision === 'month' || month > 0) {
    parts.push(month + ' month' + (month === 1 ? '' : 's'))
    if (precision === 'months' || precision === 'month') return parts.join(', ')
  }
  if (precision === 'days' || precision === 'day' || day > 0) {
    parts.push(day + ' day' + (day === 1 ? '' : 's'))
    if (precision === 'days' || precision === 'day') return parts.join(', ')
  }
  if (precision === 'hours' || precision === 'hour' || hour > 0) {
    parts.push(hour + ' hour' + (hour === 1 ? '' : 's'))
    if (precision === 'hours' || precision === 'hour') return parts.join(', ')
  }
  if (precision === 'minutes' || precision === 'minute' || min > 0) {
    parts.push(min + ' minute' + (min === 1 ? '' : 's'))
    if (precision === 'minute' || precision === 'minute') return parts.join(', ')
  }
  if (precision === 'seconds' || precision === 'second' || sec > 0) {
    parts.push(sec + ' second' + (sec === 1 ? '' : 's'))
  }
  if (parts.length === 0) return 'No Difference'
  return parts.join(', ')
  // let seconds = Math.floor(Math.abs(first - second) / 1000)
  // let minutes = Math.floor(seconds / 60)
  // let hours = Math.floor(minutes / 60)
  // let days = Math.floor(hours / 24)
  // let weeks = Math.floor(days / 7)
  // let months = Math.floor(days / 30)
}

export function formatDuration (seconds) {
  let min = Math.floor(seconds / 60)
  let sec = seconds.toFixed(0) % 60
  if (min === 0) {
    return sec + ' seconds'
  }
  if (sec < 10) sec = '0' + sec
  if (min > 60) {
    let hour = Math.floor(min / 60)
    min = min % 60
    if (min < 10) min = '0' + min
    return hour + ':' + min + ' hours'
  }
  return min + ':' + sec + ' minutes'
}
